import React, { useState } from 'react';
import { Icons } from './Icons';
import { HELP_URLS, openHelp } from '../config/helpUrls';

/**
 * Botón ? + panel con guías para empleados.
 * variant: 'icon' (header) | 'link' (bloque en login)
 */
const HelpMenu = ({ variant = 'icon', className = '' }) => {
  const [open, setOpen] = useState(false);

  if (variant === 'link') {
    return (
      <div className={`text-center text-sm mt-6 ${className}`}>
        <button
          type="button"
          className="text-teal-700 font-medium underline underline-offset-2 hover:text-teal-900"
          onClick={() => openHelp(HELP_URLS.index)}
        >
          ¿Necesitás ayuda?
        </button>
      </div>
    );
  }

  return (
    <div className={`relative ${className}`}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center touch-feedback text-gray-700"
        title="Ayuda"
        aria-label="Abrir ayuda"
        aria-expanded={open}
      >
        <Icons.HelpCircle size={18} />
      </button>
      {open && (
        <>
          <button
            type="button"
            className="fixed inset-0 z-[60] cursor-default"
            aria-label="Cerrar ayuda"
            onClick={() => setOpen(false)}
          />
          <div className="absolute right-0 top-full mt-2 z-[61] w-56 rounded-xl border border-slate-200 bg-white shadow-lg py-2 text-sm">
            <p className="px-3 py-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500">Ayuda</p>
            <button
              type="button"
              className="w-full text-left px-3 py-2.5 hover:bg-slate-50 text-slate-800"
              onClick={() => {
                setOpen(false);
                openHelp(HELP_URLS.comoFichar);
              }}
            >
              Cómo fichar
            </button>
            <button
              type="button"
              className="w-full text-left px-3 py-2.5 hover:bg-slate-50 text-slate-800"
              onClick={() => {
                setOpen(false);
                openHelp(HELP_URLS.agregarIcono);
              }}
            >
              Icono en el celular
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default HelpMenu;
